
	function TalkToHackneyNightsForm(settings){
		this.className = "TalkToHackneyNightsForm";

		this.name = "talk-to-hackney-nights";

		if(!settings) settings = {};

		settings = {
			template: ("template" in settings) ? settings.template : "form",
		};

		this.data = {
			pages: [
				{
					title: "",
					name: settings.template,
					errors: {
						general: "There are errors in your submission, please correct before continuing."
					},
					submissionUrl: "/forms/talk-to-hackney-nights",
				},
				{
					title: "Thanks",
					name: "complete"
				},
			]
		}

		this.setup(settings);
	};
	TalkToHackneyNightsForm.inheritsFrom( PageForm );

